<template>
    <nav>
        <v-toolbar flat app class="teal lighten-3">
            <v-toolbar-side-icon class="white--text" @click="drawer = !drawer"></v-toolbar-side-icon>
            <v-toolbar-title class="text-uppercase" @click="changeIndex('Home-Page')" style="cursor: pointer"> <!--Title stuff for vool toolbar-->
                <span class="font-weight-light headline">Projec</span>
                <span class="headline">Traffic</span>
            </v-toolbar-title>

            <v-toolbar-items class="hidden-sm-and-down">
                <v-btn v-for="item in toolBarItems" :key="item.title" flat color="white" class="px-5" @click="changeIndex(item.change)">
                    <v-icon left>{{item.icon}}</v-icon>
                    <span>{{item.title}}</span>
                </v-btn>
            </v-toolbar-items>

            <v-spacer> </v-spacer> <!--Fills up all  availble room-->
            
            <v-toolbar-items>
                <template v-if="signedIn">

                    <v-btn v-if="admin" flat color="white" class="hidden-sm-and-down" @click="changeIndex('Admin-Controls')">
                        <v-icon left>verified_user</v-icon>
                        <span>Admin Controls</span>
                    </v-btn>

                    <v-btn flat color="white" class="hidden-sm-and-down" @click="changeIndex('User-Profile')">
                        <v-icon left>perm_identity</v-icon>
                        <span>User Profile</span>
                    </v-btn>
                    
                    <v-btn flat color="light-grey" @click="SignOut()">
                        <span>Sign Out</span>
                        <v-icon right>exit_to_app</v-icon>
                    </v-btn>

                </template>

                <template v-else>
                    <Sign-Up></Sign-Up>
                    <Sign-In></Sign-In>
                </template>
            </v-toolbar-items>

        </v-toolbar>

        <v-navigation-drawer app v-model="drawer" class="teal accent-1">
            <v-list>

                <v-list-tile>
                    <v-list-tile-content>

                        <v-list-tile-title class="font-weight-bold">Main Categories</v-list-tile-title>

                    </v-list-tile-content>
                </v-list-tile>

                <v-list-tile v-for="link in drawerBoardTwo" :key="link.text" @click="runChange(link.change)" class="py-2 my-1"> 
                    
                    <v-list-tile-avatar>
                        <v-icon>{{link.icon}}</v-icon>
                    </v-list-tile-avatar>

                    <v-list-content>
                        <v-list-tile-title class="font-weight-light">{{link.text}}</v-list-tile-title>
                    </v-list-content>

                </v-list-tile>
                

                <!--Map Categories-->
                <v-list-tile>

                    <v-list-tile-content>

                        <v-list-tile-title class="font-weight-bold">Map Categories</v-list-tile-title>

                    </v-list-tile-content>
                </v-list-tile>

                <v-list-tile v-for="link in drawerBoard" :key="link.text" @click="runChange(link.change)" class="py-2 my-1"> 
                    
                    <v-list-tile-avatar>
                        <v-icon>{{link.icon}}</v-icon>
                    </v-list-tile-avatar>

                    <v-list-content>
                        <v-list-tile-title class="font-weight-light">{{link.text}}</v-list-tile-title>
                    </v-list-content>

                </v-list-tile>

            </v-list>
        </v-navigation-drawer>
    </nav>
</template>

<script>
import {bus} from '@/main.js'
import {database,auth} from '@/fb.js'
import Popup from './SignStuff'
import Popup2 from './SignUp'

export default {
  name: 'NavBar',
  components: {
      'Sign-Up': Popup,
      'Sign-In': Popup2
  },
  props: {
      signedIn: Boolean,
      curComp: String,
      admin: Boolean
  },
  data() {
      return {
          toolBarItems: [
              {icon: "map", title: "Map",change:'Maps-Page'},
              {icon:"message",title:"Forums",change:'Forums-Page'},
              {icon:"gps_fixed",title:"Report",change:'Report-Page'},
          ],

          drawer: false,
          
          drawerBoard: [
              {icon:"map",text:"Map",change:'Maps-Page'},
              {icon:"camera_enhance",text:"Cameras",change:'Camera-Page'}
          ],
          drawerBoardTwo: [
              {icon:"message",text:"Forums",change:'Forums-Page'},
              {icon:"perm_identity",text:"User Profile",change:"User-Profile"},
              {icon:"group",text:"About the Team",change:'Team-Page'},
              {icon:"gps_fixed",text:"Report",change:'Report-Page'},
          ]
      }
  },
  methods: {
      changeIndex: function(event) {
          this.$emit('emittedEvent',event);
      },
      SignOut() {
          auth.signOut()
      },
      runChange(toWhat) {
          bus.$emit("categoryChange",toWhat);
      }
  }
}
</script>
